import React from "react";
import { Input, Button } from "reactstrap";
import { FaMinus, FaGripVertical } from "react-icons/fa";

const AddonOptionRow = ({ option, index, onChange, onRemove, onDragStart, onDragOver, onDrop, isDragging }) => {
  return (
    <div
      draggable
      onDragStart={(e) => onDragStart(e, index)}
      onDragOver={onDragOver}
      onDrop={(e) => onDrop(e, index)}
      className={`d-flex gap-2 mb-2 align-items-center ${isDragging ? 'bg-light border-primary' : ''}`}
      style={{
        padding: '8px',
        borderRadius: '4px',
        border: isDragging ? '2px solid #007bff' : '1px solid #dee2e6',
        opacity: isDragging ? 0.5 : 1
      }}
    >
      <div className="text-muted" style={{cursor: 'grab'}}>
        <FaGripVertical />
      </div>
      <Input
        type="text"
        value={option.option}
        onChange={(e) => onChange(index, "option", e.target.value)}
        placeholder="Option Name"
        className="me-2"
      />
      <Input
        type="number"
        value={option.price}
        onChange={(e) => onChange(index, "price", e.target.value)}
        placeholder="Price"
        className="me-2"
      />
      <Input
        type="color"
        value={option.color}
        onChange={(e) => onChange(index, "color", e.target.value)}
      />
      <Button color="danger" size="sm" onClick={() => onRemove(index)}>
        <FaMinus />
      </Button>
    </div>
  );
};

export default AddonOptionRow;
